export *from './genericKendoGrid';
export *from './kendoColumnDefWrapper';
export * from './kendoListGenericColumnDef';
export *from './chart.model';
export *from './client-contact.model';
export *from './client-contactColumnDefinition';
export *from './client.model';
export *from './crossRates.model';
export *from './currency.model';
export *from './mainEntryData.model';
export *from './mainWindowSearchCriteria.model';
export *from './meta-data.model';
export *from './securityPrices.model';
export *from './portfolio.model';
export *from './transVolume.model';
export *from './transaction.model';
export *from './portfolioPerformanceDetails.model';
export *from './performancePivot.model';
export *from './userAccountData.model';
export *from './user.model';
export *from './task.model';
export *from './news-data.model';
export *from './riskProfileAssessment.model';
export *from './report.model';
export *from './reportType.model';
export *from './insa-chronos-job.model';
export *from './insa-chronos-interface-job.model'
export *from './chronos-activities-model';
export *from './chronos-post-action.model';
export *from './partnerEmail.model';
export *from './registrationFields.model';




// WEBPACK FOOTER //
// ./app/insa-models/index.ts